"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYCLevel = _interopRequireDefault(require("../KYC/KYCLevel"));
var _kycLevelsVerificationPropsHelper = require("../KYC/kycLevelsVerificationPropsHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var KYC_IMLegacyLevelsComponent = function KYC_IMLegacyLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
    levels = props.levels,
    levelIncreaseStatus = props.levelIncreaseStatus,
    openKYCSidePane = props.openKYCSidePane,
    verificationLevel = props.verificationLevel;
  return levels.map(function (level) {
    if (level.level === 1) {
      var levelProps = (0, _kycLevelsVerificationPropsHelper.getIMLevel1VerificationProps)(verificationLevel, levelIncreaseStatus);
      return /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
        key: level.level,
        verified: true,
        config: level
      }, levelProps, {
        highlightStyle: highlightStyle
      }));
    } else {
      var _levelProps = level.level === 2 ? (0, _kycLevelsVerificationPropsHelper.getIMLevel2VerificationProps)(verificationLevel, levelIncreaseStatus) : (0, _kycLevelsVerificationPropsHelper.getIMLevelVerificationProps)(level.level, verificationLevel, levelIncreaseStatus);
      return /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
        key: level.level,
        config: level
      }, _levelProps, {
        openPane: openKYCSidePane,
        highlightStyle: highlightStyle
      }));
    }
  });
};
var _default = exports["default"] = KYC_IMLegacyLevelsComponent;